import TabOptions from '../options';
import moment from 'moment';
import { serialize } from '@/utils/objUtils';
import DocumentTypes from '@/utils/constants/documentTypes';
import documentApi from '@/modules/shared/documents.api';

export class Model {
  isCompletedOtherLocation = null;
  timeStart = null;
  timeEnd = null;
}
export class Tab {
  id = 'Appointment';
  title = 'I. Cita';
  model = new Model();
  valid = true;
  options = new TabOptions(new Model());
  build = async (model) => {
    if (model.evaluationDocument && !model.evaluationDocument?.id) {
      const payload = serialize({
        file: model.evaluationDocument,
        documentTypeId: DocumentTypes.StudentEvaluation,
      });
      const { data } = await documentApi.save(payload);
      model.evaluationDocument.id = data;
    }

    const appointmentDate = moment(model.appointmentDate);
    const timeStart = moment(model.timeStart, 'HH:mm');
    const timeEnd = moment(model.timeEnd, 'HH:mm');
    return {
      tab: this.id,
      startDate: moment() //set appointment date to existing startDate
        .set({
          date: appointmentDate.get('date'),
          month: appointmentDate.get('month'),
          year: appointmentDate.get('year'),
          hour: timeStart.get('hour'),
          minute: timeStart.get('minute'),
        })
        .toDate(),
      endDate: moment() //set appointment date to existing endDate
        .set({
          date: appointmentDate.get('date'),
          month: appointmentDate.get('month'),
          year: appointmentDate.get('year'),
          hour: timeEnd.get('hour'),
          minute: timeEnd.get('minute'),
        })
        .toDate(),
      isCompletedOtherLocation: model.isCompletedOtherLocation,
      appointmentHasPractitioner: model.appointmentHasPractitioner,
      statusComment: model.statusComment,
      appointmentTherapyFlag: model.appointmentTherapyFlag ?? false,
      specialistLocationId:
        model.isCompletedOtherLocation === false
          ? model.specialist?.id
          : model.specialistLocationId,
      practitionerId: model.practitioner?.id,
      hasEducationalEvaluation: model.hasEducationalEvaluation,
      hasSignLanguageInterpreter: model.hasSignLanguageInterpreter,
      therapies: model.therapies ?? [],
      evaluationDocumentId: model.evaluationDocument?.id,
      reevaluationTimeId: model.reevaluationTime?.id,
      recommendedReevaluation: {
        hasRecommendedReevaluation: model.hasRecommendedReevaluation,
        time: model.reevaluationTime?.unitOfTime,
        period: String(model.reevaluationTime?.reevaluationPeriodId ?? ''),
        comment: model.recommendedReevaluationComment,
      },
      studentSieId: model.studentSieId,
      disciplineTypeId: model.disciplineTypeCod,
      diagnostics: (model.diagnostics ?? []).map((d) => d.id),
    };
  };
}

export default new Tab();
